import { useContext, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { popupcontext } from "../../../../context/Popupscontext";
import Close from "../../../Helpers/CloseBtn/Close";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Loader from "../../../Helpers/Loader/Loader";
import Popup from "../../../Helpers/Popup/Popup";
import { useGetSingleTechnicianQuery } from "../../../../Redux/service/Technician/Technician";
import TechnicianProfile from "./TechnicianProfile";

export default function TechnicianPopup({ technicianId, type }) {
  let { handleClose, setCurrentTechnicianId } = useContext(popupcontext);
  let { data, isLoading, refetch } = useGetSingleTechnicianQuery(technicianId, {
    skip: !technicianId,
  });

  useEffect(() => {
    if (technicianId) {
      refetch();
    }
  }, [technicianId]);

  const close = () => {
    if (type === "technician") {
      handleClose("display");
    } else {
      setCurrentTechnicianId(null);
    }
  };
  return (
    <Popup show={!!technicianId}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            headtitle={isLoading ? "Loading..." : data?.technician.name}
            avatar={true}
            avatarSrc={
              data?.technician.profile_photo
                ? `${process.env.REACT_APP_BACKEND_URL}/${data?.technician.profile_photo}`
                : ""
            }
          />
        </Modal.Title>
        <Close
          // eslint-disable-next-line react/style-prop-object
          style="close-32 close"
          close={close}
          img="Close"
        />
      </Modal.Header>
      {isLoading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : (
        <>
          <Modal.Body className="modal-body-scrollable">
            {data?.technician && <TechnicianProfile data={data.technician} />}
          </Modal.Body>
        </>
      )}
    </Popup>
  );
}
